function length(array) {
    return array.length | 0;
}
function empty(length) {
    return !(length > 0);
}
function arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function reducer(reduce) {
    return function (values) { return reduce.apply(void 0, values); };
}
export default function cross() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    var reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
    values = values.map(arrayify);
    var lengths = values.map(length);
    var j = values.length - 1;
    var index = new Array(j + 1).fill(0);
    var product = [];
    if (j < 0 || lengths.some(empty))
        return product;
    while (true) {
        product.push(index.map(function (j, i) { return values[i][j]; }));
        var i = j;
        while (++index[i] === lengths[i]) {
            if (i === 0)
                return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}
